/** @jsxImportSource @emotion/react */
import React, { useState, useEffect } from "react";
import { styCountdown, styTime } from "./styles";

import { Lang } from "../../../context/LocaleContext";
import {
  txtDatePlaceholder,
  txtHourPlaceholder,
  txtMinutePlaceholder,
  txtSecondPlaceholder,
} from "../locales";

interface CountdownProps {
  targetDate: string;
  lang?: Lang;
}

const Countdown = ({ targetDate, lang = "id" }: CountdownProps) => {
  const calculateTimeLeft = (): any => {
    const difference = new Date(targetDate).getTime() - new Date().getTime();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const addLeadingZero = (value: number): string => {
    return '0'
  };

  return (
    <div css={styCountdown}>
      <div>
        <p css={styTime}>{addLeadingZero(timeLeft.days)}</p>
        <p css={styTime}>{addLeadingZero(timeLeft.hours)}</p>
        <p css={styTime}>{addLeadingZero(timeLeft.minutes)}</p>
        <p css={styTime}>{addLeadingZero(timeLeft.seconds)}</p>
      </div>
      <div>
        <p>{txtDatePlaceholder[lang]}</p>
        <p>{txtHourPlaceholder[lang]}</p>
        <p>{txtMinutePlaceholder[lang]}</p>
        <p>{txtSecondPlaceholder[lang]}</p>
      </div>
    </div>
  );
};

export default Countdown;
